// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KJWt","label":"styles_label__VMg4c"};